import { Component, OnInit, OnDestroy, NgZone } from "@angular/core";
import { Observable } from "rxjs";
import { EntitiesService } from "../service/entities.service";
import { ActivatedRoute, Router } from "@angular/router";
import { EntityChildElement } from "./model/EntityChildElement";
import { EntityOperationModel } from "./model/EntityOperationModel";
import { EntitiesInformationService } from "app/private/sidebar-information/entity-information.service";
import { SxContextService } from "app/infrastructure/services/sxContext.service";
import { StyleService } from "app/infrastructure/services/style.service";
import { BaseComponent } from "app/helpers/components/base/base.component";

@Component({
  selector: "entity-with-childs-component",
  templateUrl: "./entity-with-childs.component.html"
})
export class EntityWithChildsComponent extends BaseComponent
  implements OnInit, OnDestroy {
  entityOperationElement: EntityOperationModel = {
    itemCarousel: [],
    title: ""
  };
  entityChildElements: EntityChildElement = {
    context: null,
    description: null,
    title: null,
    entityType: null,
    childs: [],
    actions: null,
    route: null,
    created: null,
    creationDate: null,
    entityCode: null,
    descripcionExt: null,
    categories: []
  };
  entityselectChild: EntityChildElement = {
    context: undefined,
    description: null,
    title: null,
    childs: [],
    entityType: null,
    actions: null,
    route: null,
    created: null,
    creationDate: null,
    entityCode: null,
    descripcionExt: null,
    categories: []
  };
  entityElement: Observable<EntityChildElement>;
  url: string;
  entitySelectChildCache: EntityChildElement[] = [];
  entityCacheAux: EntityChildElement[] = [];
  titleChilds: string;
  constructor(
    private entityService: EntitiesService,
    private sxContext: SxContextService,
    private aRoute: ActivatedRoute,
    private styleService: StyleService,
    public informationService: EntitiesInformationService
  ) {
    super(informationService);
  }

  ngOnInit() {
    // vacio la cache
    this.entitySelectChildCache = [];
    super.ngOnInit();
    this.getData();

    this.entityElement.subscribe(entity => {
      this.entityChildElements = entity;
      this.entityChildElements.childs.forEach(element => {
        element.categories = [];
      });

      let breadcrumbInfo = {
        description: entity.descripcionExt,
        created: entity.created,
        creationDate: entity.creationDate,
        showEdit: true // set edit button visibility to information Breadcrumb component
      };
      this.informationService.breadcrumInfo$.next(breadcrumbInfo);
      let entityOperation: EntityOperationModel = {
        itemCarousel: [],
        title: ""
      };
      entityOperation.itemCarousel = entity.actions;
      entityOperation.title = entity.description;
      this.entityOperationElement = entityOperation;

      if (entity.childs.length > 0) this.GetEntityChild(entity.childs[0]);
    });
  }

  getData() {
    this.sxContext.getContext(this.aRoute).subscribe(context => {
      this.entityElement = this.entityService.getEntityElements(context);
    });
  }

  setEntitySelected(entity: EntityChildElement, url: string) {
    this.entityService.getEntityElements(entity.context).subscribe(entity => {
      this.entityselectChild = entity;
      this.entityselectChild.title = entity.title;
      this.entitySelectChildCache.push(entity);
    });
  }

  GetEntityChild(entity: EntityChildElement) {
    this.entityCacheAux = this.entitySelectChildCache.filter(
      item =>
        item.context.subscriptionCode == entity.context.subscriptionCode &&
        item.context.channelCode == entity.context.channelCode &&
        item.context.productCode == entity.context.productCode
    );
    if (this.entityCacheAux.length > 0) {
      this.entityselectChild = this.entityCacheAux[0];
      this.entityselectChild.title = this.titleChilds;
    } else {
      if (
        entity.context.productCode != undefined &&
        entity.context.productCode != null
      ) {
        this.entityselectChild = entity;
        this.entityselectChild.title = "";
        this.entitySelectChildCache.push(entity);
      } else this.setEntitySelected(entity, this.url);
    }
  }

  ngOnDestroy() {
    this.styleService.removeStyle("MainEntityComponent");
    super.ngOnDestroy();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/entity/entityWithChilds/entiy-with-childs.component.ts